module.exports = __webpack_public_path__ + "img/events-illustration.f35ae476.svg";